"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADOBE_RGB = exports.SRGB = exports.ILLUMINANT_C = exports.ILLUMINANT_D65 = void 0;
__exportStar(require("./convert"), exports);
__exportStar(require("./invert"), exports);
var colorspace_1 = require("./colorspace");
Object.defineProperty(exports, "ILLUMINANT_D65", { enumerable: true, get: function () { return colorspace_1.ILLUMINANT_D65; } });
Object.defineProperty(exports, "ILLUMINANT_C", { enumerable: true, get: function () { return colorspace_1.ILLUMINANT_C; } });
Object.defineProperty(exports, "SRGB", { enumerable: true, get: function () { return colorspace_1.SRGB; } });
Object.defineProperty(exports, "ADOBE_RGB", { enumerable: true, get: function () { return colorspace_1.ADOBE_RGB; } });
//# sourceMappingURL=index.js.map